import { render, staticRenderFns } from "./AddTheme.vue?vue&type=template&id=5cd1a7f7&scoped=true"
import script from "./AddTheme.vue?vue&type=script&lang=js"
export * from "./AddTheme.vue?vue&type=script&lang=js"
import style0 from "./AddTheme.vue?vue&type=style&index=0&id=5cd1a7f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1a7f7",
  null
  
)

export default component.exports